import { render, staticRenderFns } from "./ExaminationYw.vue?vue&type=template&id=1f20c7cb&scoped=true"
import script from "./ExaminationYw.vue?vue&type=script&lang=js"
export * from "./ExaminationYw.vue?vue&type=script&lang=js"
import style0 from "./ExaminationYw.vue?vue&type=style&index=0&id=1f20c7cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f20c7cb",
  null
  
)

export default component.exports